(function () {
  'use strict';

  function initSlider(el) {
    if (el._pcDone) return;
    el._pcDone = true;

    var track   = el.querySelector('[data-pc-track]');
    var slides  = el.querySelectorAll('[data-pc-slide]');
    var prevBtn = el.querySelector('[data-pc-prev]');
    var nextBtn = el.querySelector('[data-pc-next]');
    var dots    = el.querySelectorAll('.pc-slider__dot');
    var href    = el.dataset.href || null;
    var total   = slides.length;
    var cur     = 0;

    if (!track || total === 0) return;

    /* single image: just navigate on click */
    if (total === 1) {
      if (href) {
        el.addEventListener('click', function (e) {
          if (e.target.closest('a') || e.target.closest('button')) return;
          window.location.href = href;
        });
      }
      return;
    }

    /* go to slide N */
    function goTo(n) {
      if (n < 0)      n = total - 1;
      if (n >= total) n = 0;
      cur = n;
      track.style.transform = 'translateX(-' + (cur * 100) + '%)';
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === cur);
      });
    }

    /* arrow click */
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(cur - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(cur + 1);
      });
    }

    /* dot click → jump to that slide */
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(i);
      });
    });

    /* touch swipe */
    var tx0 = 0, tdx = 0, dragging = false;

    el.addEventListener('touchstart', function (e) {
      /* if inside swiper, only capture if touch is clearly vertical-ish
         so horizontal swipes still work for the outer Swiper */
      tx0      = e.touches[0].clientX;
      tdx      = 0;
      dragging = true;
    }, { passive: true });

    el.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      tdx = e.touches[0].clientX - tx0;
    }, { passive: true });

    el.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      if      (tdx < -40) goTo(cur + 1);
      else if (tdx >  40) goTo(cur - 1);
      tdx = 0;
    });

    /* tap/click → navigate to product */
    if (href) {
      el.addEventListener('click', function (e) {
        if (e.target.closest('.pc-slider__arrow')) return;
        if (e.target.closest('.pc-slider__dot'))   return;
        if (e.target.closest('a'))                 return;
        if (e.target.closest('button'))            return;
        if (Math.abs(tdx) > 8)                     return;
        window.location.href = href;
      });
    }
  }

  /* ── init all sliders found in the document ── */
  function initAll() {
    document.querySelectorAll('[data-pc-slider]').forEach(initSlider);
  }

  /* ── MutationObserver: catches sliders added AFTER page load
        (Swiper clones slides, lazy sections, etc.) ── */
  function watchForNew() {
    var observer = new MutationObserver(function (mutations) {
      var found = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          /* the node itself might be a slider */
          if (node.matches && node.matches('[data-pc-slider]')) {
            initSlider(node);
            found = true;
          }
          /* or it might contain sliders */
          if (node.querySelectorAll) {
            node.querySelectorAll('[data-pc-slider]').forEach(function (el) {
              initSlider(el);
              found = true;
            });
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* ── boot ── */
  function boot() {
    initAll();
    watchForNew();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Shopify theme-editor section reload */
  document.addEventListener('shopify:section:load', initAll);

})();

/* ── Esparda 30 Sep: product-card video slide ──
   The colour's video is the last slide in each card. It plays muted while
   it is the visible slide (the slider clips the others) and pauses otherwise.
   Tapping the card still opens the product page. */
(function () {
  'use strict';
  if (window.__pcVideo) return;
  window.__pcVideo = true;
  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting && en.intersectionRatio >= 0.6) {
        if (!v.getAttribute('src') && v.dataset.src) v.src = v.dataset.src;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { threshold: [0, 0.6, 1] });

  function scan(root) {
    (root || document).querySelectorAll('video.pc-video:not([data-pc-obs])').forEach(function (v) {
      v.setAttribute('data-pc-obs', '');
      v.muted = true;
      io.observe(v);
    });
  }

  function boot() {
    scan(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType === 1 && (n.matches('video.pc-video') || n.querySelector('video.pc-video'))) {
            scan(n.matches('video.pc-video') ? n.parentNode : n);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function () { scan(document); });
})();